import FileSaver from 'file-saver'; 
import { Document, Packer, Paragraph, TextRun, HeadingLevel,
    AlignmentType,UnderlineType } from 'docx';
import { saveDocument } from '../PreliminaryTitleOpinion/savePTODoc';
import { document } from '~/api';
export const generateFTODocument = async ({ftoData = {}, titleOpinionId = 0, isPrintOnly = true}) => {
    const { 
        fileData, 
        deedData, 
        additionalData,
        approvingAttorney 
    } = ftoData;

    const fileSectionData = extractFileSectionData(fileData);

    const doc = new Document({
        sections: [{
            properties: {},
            children: [
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Final Title Opinion',
                            bold: true,
                            allCaps: false,
                            font: 'Arial-BoldMT',
                            size: 44
                        })
                    ],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                    spacing: {
                        after: 600,
                    },
                }),
                
                
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'FILE & DEED INFORMATION:',
                            bold: true,
                            allCaps: true,
                            font: 'Arial-BoldMT',
                            size: 29
                        })
                    ],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                    spacing: {
                        after: 200,
                    },
                }),
                
                createParagraph({text:'Supplementing Commitment Number: ', textData: fileSectionData.commitmentNumber,isBold: true}),
                
                createParagraph({text:'Your File Number: ', textData: fileSectionData.fileNumber,isBold: true }),
                
                createParagraph({text:'Supplementing the Preliminary Opinion on Title of the undersigned, all Requirements in Schedule B-I are hereby eliminated. All exceptions in Schedule B-II are still applicable except: ', textData: fileSectionData.b2Exceptions,isBold: true}),
                
                createParagraph({text:'The Deed, if any, required by Schedule B-I of the Commitment is identified as follows (or attach a copy): ',isBold: true}),                 
                ...createDeedSection(fileData),
                
                createParagraph({text: 'DEED OF TRUST: ',isBold:true, align: AlignmentType.CENTER, isAllCaps: true}),
                createParagraph({text:'The Deed of Trust, if any, required by Schedule B-I of the Commitment is identified as follows (or attach a copy): ', isBold: true}), 
                ...createDeedOfTrustSection(deedData),
                
                createParagraph({text:'Additional Information:  ',isBold: true, align: AlignmentType.CENTER, isAllCaps:true}),
                ...createAdditionalSection(additionalData, approvingAttorney)
            ]
        }]
    });

    if(isPrintOnly) {
        Packer.toBlob(doc).then(blob => {
            FileSaver.saveAs(blob, 'FTO Document.docx');
        });
    } else {
        return Packer.toBlob(doc).then(blob => {
            //download file
            FileSaver.saveAs(blob, 'FTO Document.docx');

            //save file to server
            const description = 'FTO Document for title opinion id: ' + titleOpinionId;
            let blobToFile = blob;
            blobToFile.lastModifiedDate = new Date();
            blobToFile.name = 'FTO Document.docx';
            let _file = {
                file: blobToFile,
                uploadLink: {},
                uploadInfo: {},
                isDeleted: false,
                type: document.DocumentType.PTO_WORD_DOC,
                uploaded: false
            };
            return saveDocument(_file, description, titleOpinionId, document.DocumentType.FTO_WORD_DOC);
        });
    }
};

const createParagraph =  ({text = '',textData = '', isBold = false, fontType = 'Arial-BoldMT', size = 24, align = AlignmentType.LEFT, isAllCaps = false}) => {
    if(textData) {
        return new Paragraph({
            children: [
                createTextRun({text, textData, isBold, isAllCaps, fontType, size}),
                createTextRun({text: textData, isBold: false, isAllCaps, fontType, size})
            ],
            alignment: align,
            spacing: {
                after: 200,
            },
        });
    }

    return new Paragraph({
        children: [ createTextRun({text, textData, isBold, isAllCaps, fontType, size})],
        alignment: align,
        spacing: {
            after: 200,
        },
    });
};

const createTextRunsParagraph =  ({textRuns = [new TextRun({})], align = AlignmentType.LEFT}) => {
    //new Paragraph({children: textRuns,alignment: AlignmentType.LEFT});
    return new Paragraph({
        children: textRuns,
        alignment: align,
        spacing: {
            after: 200,
        },
    });
};

const createTextRun = ({text = '',textData = '', isBold = false, isAllCaps=false, fontType = 'Arial-BoldMT', size = 24, isUnderlined = false, underlineType = UnderlineType.DASH}) => {
    let underline = isUnderlined &&  underlineType == UnderlineType.DASH ? '' : '';
    if(textData) {
        textData = '';
    }
    return new TextRun({
        text: text + textData + underline,
        bold: isBold,
        allCaps: isAllCaps,
        font: fontType,
        size: size,
        // underline: underline
    });
};


function extractFileSectionData(data  = {}) {
    
    if(Object.keys(data).length === 0 && data.constructor === Object) {
        return {
            fileNumber: '',
            commitmentNumber: '',
            b2Exceptions: '',
        };
    }

    const _data = JSON.parse(data?.section?._data);

    return {
        fileNumber: _data?.fileNumber,
        commitmentNumber: _data?.commitmentNumber,
        b2Exceptions: _data?.b2Exceptions,
    };
}

function extractAdditionalSectionData(data  = {}) {
    if((Object.keys(data).length === 0 && data.constructor === Object) || !Object.prototype.hasOwnProperty.call(data.section, '_data')) {
        return {
            endorsements: '',
            taxYear: '',
            donorPolicyRecipient: '',
            ownerPolicyRecipient: '',
            lenderPolicyRecipient: '',
            attorneyCopyRecipient: '',
            additionalInfo: ''
        };
    }

    const _data = Object.prototype.hasOwnProperty.call(data.section, '_data') && JSON.parse(data?.section?._data);

    let endorsementsArr = Array.isArray(_data?.endorsements) ? _data?.endorsements.map((x)=> x.label) : '';
    let endorsements = Array.isArray(_data?.endorsements) ? endorsementsArr.join() :  _data?.endorsements?.label;
    return {
        endorsements: endorsements,
        taxYear: _data?.taxYear,
        donorPolicyRecipient: _data?.donorPolicyRecipient,
        ownerPolicyRecipient: _data?.ownerPolicyRecipient,
        lenderPolicyRecipient: _data?.lenderPolicyRecipient,
        attorneyCopyRecipient: _data?.attorneyCopyRecipient,
        additionalInfo: _data?.additionalInfo

    };
}

const createDeedSection =(data = {}) => {
    const res = Array.isArray(data?.sectionDetails) && data?.sectionDetails.map((fileSectionDetailData, index) => {
        let deedNo = +index + 1;
        let deedTitle = createParagraph({text:'Deed #' + deedNo,isBold: true,isUnderlined: true});

        let dated = fileSectionDetailData?._data?.dated != undefined ? new Date(fileSectionDetailData?._data?.dated).toDateString() : '';
        let recordedOn = fileSectionDetailData?._data?.recordedOn != undefined ? new Date(fileSectionDetailData?._data?.recordedOn).toDateString() : '';
        let at = fileSectionDetailData?._data?.recordedOn != undefined ? new Date(fileSectionDetailData?._data?.recordedOn).toLocaleTimeString() : '';
        if(index == 0) {
            return [
                createParagraph({text:'Grantor(s): ', textData: fileSectionDetailData?._data?.grantors,isBold: true}),       
                createParagraph({text:'Grantee(s): ', textData: fileSectionDetailData?._data?.grantees, isBold: true}),
                createTextRunsParagraph({textRuns:[
                    createTextRun({text:'Purchase Price: ', textData: fileSectionDetailData?._data?.purchasePrice,isBold: true}),
                    createTextRun({text: fileSectionDetailData?._data?.purchasePrice, isBold: false}),
                    createTextRun({text:', dated  ', textData: dated == 'Invalid Date' ? '' : dated,isBold:true}),
                    createTextRun({text:  dated == 'Invalid Date' ? '' : dated,isBold:false})
                ]}),
                createTextRunsParagraph({textRuns:[
                    createTextRun({text:'And recorded on ', textData: recordedOn, isBold:true}),
                    createTextRun({text: recordedOn == 'Invalid Date' ? '' : recordedOn, isBold: false}),
                    createTextRun({text:' At    ',isBold:true}),
                    createTextRun({text:  at == 'Invalid Date' ? '' : at, isBold: false}),
                ]}),
                createTextRunsParagraph({textRuns:[
                    createTextRun({text:'In Book  ', textData: fileSectionDetailData?._data?.book,isBold: true}), 
                    createTextRun({text: fileSectionDetailData?._data.book, isBold: false}), 
                    createTextRun({text:', page   ', textData: fileSectionDetailData?._data?.page,isBold: true}), 
                    createTextRun({text: fileSectionDetailData?._data?.page, isBold: false}), 
                    createTextRun({text: ', county registry  ', textData: fileSectionDetailData?._data?.countyRegistry,isBold: true}),
                    createTextRun({text: fileSectionDetailData?._data?.countyRegistry,isBold: false})
                ]})
            ];
        }
        return [
            deedTitle,
            createParagraph({text:'Grantor(s): ', textData: fileSectionDetailData?._data?.grantors,isBold: true}),       
            createParagraph({text:'Grantee(s): ', textData: fileSectionDetailData?._data?.grantees, isBold: true}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'Purchase Price: ', textData: fileSectionDetailData?._data?.purchasePrice,isBold: true}),
                createTextRun({text: fileSectionDetailData?._data?.purchasePrice, isBold: false}),
                createTextRun({text:', dated  ', textData: dated,isBold:true}),
                createTextRun({text: dated == 'Invalid Date' ? '' : dated,isBold:false})
            ]}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'And recorded on ', textData: recordedOn, isBold:true}),
                createTextRun({text: recordedOn == 'Invalid Date' ? '' : recordedOn, isBold: false}),
                createTextRun({text:' At    ',isBold:true}),
                createTextRun({text: at == 'Invalid Date' ? '' : at, isBold: false}),
            ]}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'In Book  ', textData: fileSectionDetailData?._data?.book,isBold: true}), 
                createTextRun({text: fileSectionDetailData?._data?.book, isBold: false}), 
                createTextRun({text:', page   ', textData: fileSectionDetailData?._data?.page,isBold: true}), 
                createTextRun({text: fileSectionDetailData?._data?.page, isBold: false}), 
                createTextRun({text: ', county registry  ', textData: fileSectionDetailData?._data?.countyRegistry,isBold: true}),
                createTextRun({text: fileSectionDetailData?._data?.countyRegistry,isBold: false})
            ]}),
        ];
    });

    let sectionDeedData = [];
    try{sectionDeedData = [].concat.apply([], res);}catch(err){console.error(err);}
    return sectionDeedData;
};

const createDeedOfTrustSection =(data = {}) => {
    const res = data.sectionDetails.map((deedOfTrustSectionDetailData, index) => {
        let dated = deedOfTrustSectionDetailData._data.dated != undefined ? new Date(deedOfTrustSectionDetailData._data.dated).toDateString() : '';
        let recordedOn = deedOfTrustSectionDetailData._data.recordedOn != undefined ? new Date(deedOfTrustSectionDetailData._data.recordedOn).toDateString() : '';
        let at = deedOfTrustSectionDetailData._data.recordedOn != undefined ? new Date(deedOfTrustSectionDetailData._data.recordedOn).toLocaleTimeString() : '';
        let reRecordedOn = deedOfTrustSectionDetailData._data.reRecordedOn != undefined ? new Date(deedOfTrustSectionDetailData._data.reRecordedOn).toDateString() : '';
        let at_reRecordedOn = deedOfTrustSectionDetailData._data.reRecordedOn != undefined ? new Date(deedOfTrustSectionDetailData._data.reRecordedOn).toLocaleTimeString() : '';
        return [
            index > 0 ? createParagraph({text:'Deed of Trust #2 ',isBold:true, align: AlignmentType.LEFT, isAllCaps: false,isUnderlined:true}) : new Paragraph({}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'Mortgagor(s):  ', isBold:true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.mortgators, isBold:false})
            ]}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'Trustee:  ', isBold:true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.trustee, isBold:false})
            ]}),
            createTextRunsParagraph({textRuns:[
                createTextRun({text:'Beneficiary:  ', isBold:true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.beneficiary, isBold:false})
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'Securing the principal amount of  ',isBold: true }),
                createTextRun({text: deedOfTrustSectionDetailData?._data.securingAmountOf, isBold: false }),
                createTextRun({text: ', dated  ',isBold: true}),
                createTextRun({text: dated == 'Invalid Date' ? '' : dated, isBold: false }),
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'And recorded on ',isBold: true}),
                createTextRun({text: recordedOn == 'Invalid Date' ? '' : recordedOn, isBold: false }),
                createTextRun({text: ' At    ',isBold: true}),
                createTextRun({text: at == 'Invalid Date' ? '' : at, isBold: false }),
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'In Book  ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.book, isBold: false }),
                createTextRun({text: ', page   ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.page, isBold: false }),
                createTextRun({text: ', county registry  ',isBold: true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.countyRegistry, isBold: false }),
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'And re-recorded, if applicable, on  ',isBold: true}),
                createTextRun({text: reRecordedOn == 'Invalid Date' ? '' : reRecordedOn, isBold: false }),
                createTextRun({text: ' At    ',isBold: true}),
                createTextRun({text: at_reRecordedOn == 'Invalid Date' ? '' : at_reRecordedOn, isBold: false }),
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'In Book  ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.reBook, isBold: false }),
                createTextRun({text: ', Page   ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.rePage, isBold: false }),
                createTextRun({text: ', county registry  ',isBold: true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.reCountyRegistry, isBold: false }),
            ]}),
            createTextRunsParagraph({textRuns: [
                createTextRun({text:'Assigned to  ',isBold: true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.assignedTo, isBold: false }),
                createTextRun({text: ' In Book  ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.assignedBook, isBold: false }),
                createTextRun({text: ', Page   ',isBold: true}), 
                createTextRun({text: deedOfTrustSectionDetailData?._data?.assignedPage, isBold: false }),
                createTextRun({text: ', county registry  ',isBold: true}),
                createTextRun({text: deedOfTrustSectionDetailData?._data?.assignedCountyRegistry, isBold: false }),
            ]}),
            createParagraph({text:`The Deed of Trust identified above is a valid ${deedOfTrustSectionDetailData?._data?.lienOrder ? deedOfTrustSectionDetailData?._data?.lienOrder?.label : ''}  Lien on the property. `, isBold: true }),
            
        ];
    });
    const sectionDeedOfTrustData = [].concat.apply([], res);
    return sectionDeedOfTrustData;
};

const createAdditionalSection = (data = {}, approvingAttorney) => {
    const additionalSectionData = extractAdditionalSectionData(data);
    return [
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Taxes are paid through and including:  ',isBold: true}),
            createTextRun({text: additionalSectionData?.taxYear, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Check ALTA Endorsements requested, if any: ',isBold: true}),
            createTextRun({text: additionalSectionData?.endorsements, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Additional Information: ',isBold: true}),
            createTextRun({text: additionalSectionData?.additionalInfo, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Send Owner’s Title Policy to: ',isBold: true}),
            createTextRun({text: additionalSectionData?.ownerPolicyRecipient, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Send Lender’s Title Policy to:  ',isBold: true}),
            createTextRun({text: additionalSectionData?.lenderPolicyRecipient, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Send Attorney’s Title Policy to: ',isBold: true}),
            createTextRun({text: additionalSectionData?.attorneyCopyRecipient, isBold: false })
        ]}),
        createTextRunsParagraph({textRuns: [
            createTextRun({text:'Certifying Attorney’s Signature: ',isBold: true}),
            createTextRun({text: approvingAttorney, isBold: false })
        ]}),
    ];
}; 

